export const mypRoles = [
  { id: 1, name: "SuperAdmin" },
  { id: 2, name: "Corporate Admin" },
  { id: 3, name: "General Manager" },
  { id: 4, name: "IT Person" },
  { id: 5, name: "Free User" },
  { id: 6, name: "Accountant" },
  { id: 7, name: "Department Manager" },
  { id: 8, name: "Assistant General Manager" },
  { id: 9, name: "Owner" },
  { id: 10, name: "Corporate Regular" },
  { id: 11, name: "General Manager with PO" },
  { id: 12, name: "Night Audit" },
  { id: 13, name: "Corporate Accounting" },
  { id: 14, name: "Income Journal Only" },
  { id: 27, name: "MYP2-Onboarding-HG" },
];

export const mypPMSlist = [
  { name: "Opera" },
  { name: "Nova" },
  { name: "ChoiceAdvantage" },
  { name: "OnQuee" },
  { name: "VisualMatrix" },
  { name: "Fosse" },
  { name: "FOLS" },
  { name: "NiteVision" },
  { name: "CheckInn" },
  { name: "WynGuest" },
  { name: "FS" },
  { name: "Galaxy" },
  { name: "HotelKey" },
  { name: "RoomMaster" },
  { name: "SkyTouch" },
  { name: "SpringerMiller" },
  { name: "Win" },
  { name: "RoomKey" },
  { name: "CloudPM" },
  { name: "AnandPMS" },
  { name: "WebRezPro" },
  { name: "InnRoad" },
  { name: "Resnexus" },
  { name: "StayNTouch" },
  { name: "RDP" },
  { name: "Agilysys" },
  { name: "Maestro" },
  { name: "Protel" },
  { name: "Redistay" },
  { name: "MSIJonasChorum" },
  { name: "InforHMS" },
  { name: "Fivestar" },
  { name: "Epitome" },
  { name: "Skyware" },
  { name: "AutoClerk" },
  { name: "Abacus" },
  { name: "G3" },
  { name: "LuxuryRes" },
  { name: "Toast POS" },
  { name: "PEP" },
  { name: "SynXis Property Hub" },
  { name: "Think Reservation" },
];
